
    var content = require("!!../../../../../../../node_modules/.pnpm/css-loader@2.1.1_webpack@4.46.0/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??postcss!../../../../../../../node_modules/.pnpm/sass-loader@10.5.2_node-sass@8.0.0_webpack@4.46.0/node_modules/sass-loader/dist/cjs.js??ref--7-3!./WelcomeSplash.scss");
    var insertCss = require("!../../../../../../../node_modules/.pnpm/isomorphic-style-loader@4.0.0/node_modules/isomorphic-style-loader/lib/insertCss.js");

    if (typeof content === 'string') {
      content = [[module.id, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (module.hot && typeof window !== 'undefined' && window.document) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../../node_modules/.pnpm/css-loader@2.1.1_webpack@4.46.0/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??postcss!../../../../../../../node_modules/.pnpm/sass-loader@10.5.2_node-sass@8.0.0_webpack@4.46.0/node_modules/sass-loader/dist/cjs.js??ref--7-3!./WelcomeSplash.scss", function() {
        content = require("!!../../../../../../../node_modules/.pnpm/css-loader@2.1.1_webpack@4.46.0/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??postcss!../../../../../../../node_modules/.pnpm/sass-loader@10.5.2_node-sass@8.0.0_webpack@4.46.0/node_modules/sass-loader/dist/cjs.js??ref--7-3!./WelcomeSplash.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  